import React, { useState } from 'react'
import { useQuery, useMutation, gql } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import DataTable from '../components/DataTable'
import orderBy from 'lodash/orderBy'
import { getBanners, editBanner, deleteBanner } from '../apollo'
import SearchBar from '../components/TableHeader/SearchBar'
import useGlobalStyles from '../utils/globalStyles'
import { customStyles } from '../utils/tableCustomStyles'
import { RowActionMenu } from '../components/UI/RowActionMenu'
import EditOutlined from '@mui/icons-material/EditOutlined'
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded'
import { Box, Container, Modal, Button } from '@mui/material'
import AddRounded from '@mui/icons-material/AddRounded'
import { raisedButtonSx } from '../components/UI/Depth'
import TableHeader from '../components/TableHeader'
import BannerComponent from '../components/Banner/Banner'
import { modalOverlay, modalCard } from '../utils/modalStyles'

const GET_BANNERS = gql`
  ${getBanners}
`
const EDIT_BANNER = gql`
  ${editBanner}
`
const DELETE_BANNER = gql`
  ${deleteBanner}
`

const Banners = props => {
  const { t } = props
  const [editModal, setEditModal] = useState(false)
  const [addModal, setAddModal] = useState(false)
  const [banner, setBanner] = useState(null)
  const [searchQuery, setSearchQuery] = useState('')
  const onChangeSearch = e => setSearchQuery(e.target.value)
  const [mutateEdit] = useMutation(EDIT_BANNER)
  const [mutateDelete] = useMutation(DELETE_BANNER, {
    refetchQueries: [{ query: GET_BANNERS }]
  })
  const { data, error: errorQuery, loading: loadingQuery, refetch } = useQuery(
    GET_BANNERS
  )
  const toggleModal = banner => {
    setEditModal(!editModal)
    setBanner(banner)
  }

  console.log('a')

  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field] && isNaN(row[field])) {
        return row[field].toLowerCase()
      }

      return row[field]
    }

    return orderBy(rows, handleField, direction)
  }

  const renderMedia = url => {
    const fileType = url.split('.').pop()
    if (['mp4'].includes(fileType)) {
      return (
        <video
          className="img-responsive"
          style={{ width: 30, height: 30, borderRadius: 15 }}
          src={
            url ||
            'https://res.cloudinary.com/dc6xw0lzg/image/upload/v1729069288/default_zfwkys.png'
          }
        />
      )
    }
    return (
      <img
        className="img-responsive"
        style={{ width: 30, height: 30, borderRadius: 15 }}
        src={
          url ||
          'https://res.cloudinary.com/dc6xw0lzg/image/upload/v1729069288/default_zfwkys.png'
        }
        alt=""
      />
    )
  }
  const columns = [
    {
      name: t('Image'),
      cell: row => <>{renderMedia(row.file)}</>
    },
    {
      name: t('Title'),
      sortable: true,
      selector: 'title'
    },
    {
      name: t('Description'),
      sortable: true,
      selector: 'description'
    },
    {
      name: t('Screen'),
      sortable: true,
      selector: 'screen'
    },
    {
      name: t('Action'),
      sortable: true,
      selector: 'action'
    },
    {
      name: t('Action'),
      cell: row => <>{actionButtons(row)}</>
    }
  ]
  const regex =
    searchQuery.length > 2 ? new RegExp(searchQuery.toLowerCase(), 'g') : null
  const filtered =
    searchQuery.length < 3
      ? data && data.banners
      : data &&
        data.banners.filter(banner => {
          return banner.title.toLowerCase().search(regex) > -1
        })

  const actionButtons = row => {
    return (
      <>
        <div>
          <RowActionMenu
            label={t('Action')}
            actions={[
              {
                label: t('Edit'),
                icon: EditOutlined,
                tone: 'primary',
                onClick: () => {
                  toggleModal(row)
                }
              },
              {
                label: t('Delete'),
                icon: DeleteOutlineRounded,
                tone: 'danger',
                divider: true,
                confirm: {
                  title: `${t('Delete')}?`,
                  message: t('DeleteConfirm'),
                  cancelLabel: t('Cancel')
                },
                onClick: () => {
                  mutateDelete({ variables: { id: row._id } })
                }
              }
            ]}
          />
        </div>
      </>
    )
  }
  const globalClasses = useGlobalStyles()
  return (
    <>
      <Header
        action={
          <Button
            startIcon={<AddRounded />}
            onClick={() => setAddModal(true)}
            sx={raisedButtonSx}>
            {`${t('Add')} ${t('Banner')}`}
          </Button>
        }
      />
      {/* Page content */}
      <Container className={globalClasses.flex} fluid>
        {errorQuery ? (
          <span>
            `${t('Error')}! ${errorQuery.message}`
          </span>
        ) : null}
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <DataTable
            subHeader={true}
            subHeaderComponent={
              <SearchBar
                value={searchQuery}
                onChange={onChangeSearch}
                onClick={() => refetch()}
              />
            }
            title={<TableHeader title={t('Banners')} />}
            columns={columns}
            data={filtered}
            pagination
            progressPending={loadingQuery}
            progressComponent={<CustomLoader />}
            sortFunction={customSort}
            defaultSortField="name"
            customStyles={customStyles}
          />
        )}
        <Modal
          open={editModal}
          onClose={() => {
            toggleModal(null)
          }}
          sx={modalOverlay}>
          <Box sx={modalCard('md')}>
            <BannerComponent
              banner={banner}
              onClose={() => toggleModal(null)}
            />
          </Box>
        </Modal>
        <Modal
          open={addModal}
          onClose={() => setAddModal(false)}
          sx={modalOverlay}>
          <Box sx={modalCard('md')}>
            <BannerComponent onClose={() => setAddModal(false)} />
          </Box>
        </Modal>
      </Container>
    </>
  )
}

export default withTranslation()(Banners)
